import { DATA_LINK_ACTIONS } from '../../actions/datalinks';

const initialState = {
  dataLinks: [],
  documents: {},
  selections: {},
  parameters: {},
  counts: {}
};

const DataLinksReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_LOGOUT' || 'INVALID_USER':
      return initialState;
    case DATA_LINK_ACTIONS.DATA_LINKS_LOADED:
      return {
        ...state,
        dataLinks: action.payload
      };
    case DATA_LINK_ACTIONS.DATA_LINK_PARAMETERS_SET: {
      const newState = { ...state };
      newState.parameters[action.payload.dataLinkId] =
        action.payload.parameters;
      return newState;
    }
    case DATA_LINK_ACTIONS.DATA_LINK_DOCUMENTS_COUNTED: {
      const newCounts = { ...state.counts };
      newCounts[action.payload.dataLinkId] = action.payload.count
        ? parseInt(action.payload.count)
        : 0;
      return {
        ...state,
        counts: newCounts
      };
    }
    case DATA_LINK_ACTIONS.DATA_LINK_DOCUMENTS_APPENDED: {
      const docs = { ...state.documents };
      const newDocs = [
        ...docs[action.payload.dataLinkId].documents,
        ...action.payload.documents
      ];
      docs[action.payload.dataLinkId] = {
        documents: newDocs,
        snapshotActive: true
      };
      return {
        ...state,
        documents: docs
      };
    }
    case DATA_LINK_ACTIONS.DATA_LINK_DOCUMENTS_LOADED: {
      const docs = { ...state.documents };
      docs[action.payload.dataLinkId] = {
        ...action.payload,
        snapshotActive: true
      };
      return {
        ...state,
        documents: docs
      };
    }
    case DATA_LINK_ACTIONS.DATA_LINK_DOCUMENT_SELECTED: {
      const newSelections = { ...state.selections };
      newSelections[action.payload.dataLinkId] = action.payload;

      return {
        ...state,
        lastDataLinkId: action.payload.dataLinkId,
        selections: { ...newSelections }
      };
    }
    default:
      return state;
  }
};

export default DataLinksReducer;
